import React, { ReactElement } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute: React.FC<{ children: ReactElement }> = ({
  children,
}) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  // return isAuthenticated ? children : <Navigate to="/login" replace />;
  // If the user is not authenticated, redirect them to the login page
  if (!isAuthenticated) {
    // Save the current location (the intended route) in the state
    return <Navigate to="/login" state={{ from: location }} />;
  }

  return children;
};
